/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomInputFile = {
  contentType: string;
  name: string;
  size: number;
};

export type UploadRequestInput = {
  id: string | number;
  originalFileName: string;
};

export type For400FoaIssueSignedUploadUrLsMutationVariables = Exact<{
  chatRoomId: string | number;
  files: Array<Types.ChatRoomInputFile> | Types.ChatRoomInputFile;
}>;


export type For400FoaIssueSignedUploadUrLsMutation = { for400FOA__issueSignedUploadURLs: { items: Array<{ uploadRequestId: string, signedUploadURL: string }> } };

export type For400FoaCompleteUploadMutationVariables = Exact<{
  chatRoomId: string | number;
  uploadRequestIds: Array<string | number> | string | number;
  uploadRequests?: Array<Types.UploadRequestInput | null | undefined> | Types.UploadRequestInput | null | undefined;
}>;


export type For400FoaCompleteUploadMutation = { for400FOA__completeUpload: boolean };


export const For400FoaIssueSignedUploadUrLsDocument = gql`
    mutation for400FOAIssueSignedUploadURLs($chatRoomId: ID!, $files: [ChatRoomInputFile!]!) {
  for400FOA__issueSignedUploadURLs(chatRoomId: $chatRoomId, files: $files) {
    items {
      uploadRequestId
      signedUploadURL
    }
  }
}
    `;

/**
 * __useFor400FoaIssueSignedUploadUrLsMutation__
 *
 * To run a mutation, you first call `useFor400FoaIssueSignedUploadUrLsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFor400FoaIssueSignedUploadUrLsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFor400FoaIssueSignedUploadUrLsMutation({
 *   variables: {
 *     chatRoomId: // value for 'chatRoomId'
 *     files: // value for 'files'
 *   },
 * });
 */
export function useFor400FoaIssueSignedUploadUrLsMutation(options: VueApolloComposable.UseMutationOptions<For400FoaIssueSignedUploadUrLsMutation, For400FoaIssueSignedUploadUrLsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<For400FoaIssueSignedUploadUrLsMutation, For400FoaIssueSignedUploadUrLsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<For400FoaIssueSignedUploadUrLsMutation, For400FoaIssueSignedUploadUrLsMutationVariables>(For400FoaIssueSignedUploadUrLsDocument, options);
}
export type For400FoaIssueSignedUploadUrLsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<For400FoaIssueSignedUploadUrLsMutation, For400FoaIssueSignedUploadUrLsMutationVariables>;
export const For400FoaCompleteUploadDocument = gql`
    mutation for400FOACompleteUpload($chatRoomId: ID!, $uploadRequestIds: [ID!]!, $uploadRequests: [UploadRequestInput]) {
  for400FOA__completeUpload(
    chatRoomId: $chatRoomId
    uploadRequestIds: $uploadRequestIds
    uploadRequests: $uploadRequests
  )
}
    `;

/**
 * __useFor400FoaCompleteUploadMutation__
 *
 * To run a mutation, you first call `useFor400FoaCompleteUploadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFor400FoaCompleteUploadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFor400FoaCompleteUploadMutation({
 *   variables: {
 *     chatRoomId: // value for 'chatRoomId'
 *     uploadRequestIds: // value for 'uploadRequestIds'
 *     uploadRequests: // value for 'uploadRequests'
 *   },
 * });
 */
export function useFor400FoaCompleteUploadMutation(options: VueApolloComposable.UseMutationOptions<For400FoaCompleteUploadMutation, For400FoaCompleteUploadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<For400FoaCompleteUploadMutation, For400FoaCompleteUploadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<For400FoaCompleteUploadMutation, For400FoaCompleteUploadMutationVariables>(For400FoaCompleteUploadDocument, options);
}
export type For400FoaCompleteUploadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<For400FoaCompleteUploadMutation, For400FoaCompleteUploadMutationVariables>;